import { get, set } from 'lodash'
import { Tooltip, Button } from 'antd'
import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { t } from 'helpers/i18n'
import { isReadOnly } from 'helpers/formViews'
import Icon from 'elements/Icon'
import FormView from 'containers/Assets/Tasks/FormView'

export default createChildListViewComponent({
  entityName: entityNames.assets,
  childName: 'tasks',
  createButtonTextId: 'scheduleJob',
  createButtonLinkTarget: {
    formSize: 'md',
    formComponent: FormView,
  },
  primaryLinkTarget: 'assetTaskRecord',
  secondaryLinkTargets: ['jobTemplateRecord'],
  secondaryLinkTargetsRecipeFactories: {
    jobTemplateRecord: (self, record) => (draft) => {
      const item = draft.find((one) => one.id === self.state.editDrawerLinkTargetRecord.id)
      const path = self.state.editDrawerLinkTargetColumn.dtoFieldName
      const oldText = get(item, path)
      const newText = record.name

      draft.forEach((each) => {
        if (get(each, path) === oldText) {
          set(each, path, newText)
        }
      })
    },
  },
  extraTableButtons: (self) => (
    <Tooltip title={t('copySchedule')}>
      <Button
        onClick={() => self.props.onTableExtraButtonsClick({ key: 'copySchedule' })}
        disabled={isReadOnly(self)}
        size="small"
      >
        <Icon type="ContentCopy" />
      </Button>
    </Tooltip>
  ),
  allowCustomize: (self) => true,
})()
